import deepEqual from 'fast-deep-equal';

export const options = {
  pure: true,
  areStatePropsEqual: deepEqual,
  areMergedPropsEqual: deepEqual,
};

export default {
  options,
};
